import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-screen bg-background px-4 py-10 sm:px-6">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border border-border/70 bg-card p-6 shadow-sm sm:p-8">
        <h1 className="text-2xl font-semibold tracking-tight">
          Términos de Servicio - Clara
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Al usar Clara, aceptás estas condiciones de uso.
        </p>

        <div className="mt-6 space-y-4 text-sm leading-6 text-foreground/90">
          <p>
            El acceso a la plataforma está destinado a usuarios autorizados por
            su comunidad.
          </p>
          <p>
            No está permitido usar la plataforma para suplantación de identidad
            o para recopilar información personal de terceros sin autorización.
          </p>
          <p>
            Para consultas sobre estos términos, escribinos a{" "}
            <a
              href="mailto:legales@daleclara.com"
              className="underline underline-offset-2"
            >
              legales@daleclara.com
            </a>
            .
          </p>
        </div>

        <div className="mt-8">
          <Link to="/login" className="text-sm underline underline-offset-2">
            Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}
